module.exports = __webpack_public_path__ + "static/media/puff.27e2ef14.svg";